import { postJson, post, get, deleteApi } from "../axios4";

const RESOURCE_BASE_PATH = "/yunqi-ai-api";

// 分页查询推荐问题列表
export const getRecommended = (p) =>
  get(`${RESOURCE_BASE_PATH}/ai-recommend-question/page`, p);

// 点赞、踩接口
export const likeAndStep = (p) =>
  post(`${RESOURCE_BASE_PATH}/chat/setLikeOrDislikeStatus`, p);

// 查询短信生成历史记录接口（取前20条）
export const AIList = p => get(`${RESOURCE_BASE_PATH}/sms-ai-content-record/list`, p);

// 生成AI短信文案接口
export const monkey = p => postJson(`${RESOURCE_BASE_PATH}/sms-ai-content-record/buildContent`, p);

// 根据请求ID查询应答信息接口
export const AI = p => get(`${RESOURCE_BASE_PATH}/sms-ai-content-record/getResponse/${p}`);

// 重新生成文案接口
export const AIAgain = p => get(`${RESOURCE_BASE_PATH}/sms-ai-content-record/reBuild/${p}`);

// 意图识别接口
export const recognizeIntent = p => postJson(`${RESOURCE_BASE_PATH}/chat/recognize-intent`, p);

// 创建对话接口
export const createConversation = p => postJson(`${RESOURCE_BASE_PATH}/chat/conversation/create`, p);

// 分页查询对话列表接口
export const getConversationPage = p => postJson(`${RESOURCE_BASE_PATH}/chat/conversation/page`, p);

// 删除对话接口
export const deleteConversation = p => deleteApi(`${RESOURCE_BASE_PATH}/chat/${p}`);

// AGENT_BI场景对话
export const reportData = p => postJson(`${RESOURCE_BASE_PATH}/ai/dataReport/report`, p);

// 根据请求的数据报表reqId获取数据明细
export const queryData = p => postJson(`${RESOURCE_BASE_PATH}/ai/dataReport/queryData`, p);

// 分页查询对话消息接口
export const getMessagesPage = p => postJson(`${RESOURCE_BASE_PATH}/chat/messages/page`, p);

// 根据对话ID查询报表详情JSON
export const getReportById = msgId => get(`${RESOURCE_BASE_PATH}/ai-analysis/report/${msgId}`);

// 根据对话ID查询报表详情JSON
export const exportAiAnalysis = p => postJson(`${RESOURCE_BASE_PATH}/ai-analysis/export`, p);

// 根据对话ID查询选择项JSON
export const getSelectData = (msgId)=> get(`${RESOURCE_BASE_PATH}/ai-analysis/select-items/${msgId}`);

// 根据对话ID查询选择项数据JSON
export const getSelectDataJson = (conversationId) => get(`${RESOURCE_BASE_PATH}/ai-analysis/select-items-data-json/${conversationId}`);

// 根据对话ID查询人群JSON
export const getCrowdJson = p => postJson(`${RESOURCE_BASE_PATH}/smart-crowd/crowds`, p);

// 确认所选人群方案
export const confirmCrowd = p => postJson(`${RESOURCE_BASE_PATH}/smart-crowd/crowds/confirm`, p);

// 确认生成人群
export const generateCrowd = p => postJson(`${RESOURCE_BASE_PATH}/smart-crowd/crowds/generate`, p);

// 查询信息收集表单
export const getCollectForm = p => postJson(`${RESOURCE_BASE_PATH}/smart-crowd/collect-form`, p);

// 根据对话ID查询人群JSON
export const getCrowdJsonMarketing = p => postJson(`${RESOURCE_BASE_PATH}/marketing-strategy/crowds`, p);

// 确认所选人群方案
export const confirmCrowdMarketing = p => postJson(`${RESOURCE_BASE_PATH}/marketing-strategy/crowds/confirm`, p);

// 确认生成人群
export const generateCrowdMarketing = p => postJson(`${RESOURCE_BASE_PATH}/marketing-strategy/crowds/generate`, p);

// 获取营销画布预览
export const getCanvasPreview = p => get(`${RESOURCE_BASE_PATH}/marketing-strategy/canvas/preview`, p);

// 创建营销画布
export const createCanvas = p => postJson(`${RESOURCE_BASE_PATH}/marketing-strategy/canvas/create`, p);

// 查询信息收集表单
export const getCollectFormMarketing = p => postJson(`${RESOURCE_BASE_PATH}/marketing-strategy/collect-form`, p);

// 查询策略锚点当前 style
export const getStrategyStyle = p => get(`${RESOURCE_BASE_PATH}/marketing-strategy/strategy-message/style`, p);

// 查询免责声明
export const getDisclaimerChecked = (p) => get(`${RESOURCE_BASE_PATH}/common/user-access/exists`, p);

// 更新免责声明
export const updateDisclaimerChecked = p => post(`${RESOURCE_BASE_PATH}/common/user-access/add`, p);

// 提交帮助与反馈
export const submitFeedback = p => postJson(`${RESOURCE_BASE_PATH}/ai-feedback/add`, p);

